import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { createUserAsync, clearCreationStatus, fetchUsersAsync } from '../../../../redux/slice/userDownlineList/usersSlice';

const AddUserForm = ({
    openAddUser,
    setOpenAddUser,
    uplineUserData
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [isCommission, setIsCommission] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const { creationStatus, error } = useSelector((state) => state.userDownline);
    useEffect(() => {
        if (creationStatus === 'success') {
            NotificationManager.success('User created successfully', '', 1000);
            if (isAuthenticated) {
                dispatch(fetchUsersAsync({
                    page: 1,
                    limit: 10,
                    search: '',
                    sortBy: 'createdAt',
                    sortOrder: 'desc',
                    master_id: null
                }));
                setOpenAddUser(false);
                form.resetFields();
            }
        } else if (creationStatus === 'error') {
            console.log('error:', error)
            NotificationManager.error(error?.message || 'Failed to create user', '', 1000);
        }
    }, [creationStatus, error, dispatch, setOpenAddUser, form]);

    const onFinish = (values) => {
        setLoading(true)
        const data = {
            ...values,
            master_id: userdata.id,
            user_type: 'User',
            registration_date: new Date().toISOString().split('T')[0],
            rolling_commission: isCommission ? 'Yes' : 'No',
            rolling_commission_binary: isCommission ? values.rolling_commission_binary || 0 : 0,
            rolling_commission_bookmaker: isCommission ? values.rolling_commission_bookmaker || 0 : 0,
            rolling_commission_casino: isCommission ? values.rolling_commission_casino || 0 : 0,
            rolling_commission_fancy: isCommission ? values.rolling_commission_fancy || 0 : 0,
            rolling_commission_matka: isCommission ? values.rolling_commission_matka || 0 : 0,
            rolling_commission_sportbook: isCommission ? values.rolling_commission_sportbook || 0 : 0,
            rolling_commission_virtualsport: isCommission ? values.rolling_commission_virtualsport || 0 : 0
        };
        if (isAuthenticated) {
            dispatch(createUserAsync(data));
        }
        setLoading(false)
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Modal
            title={'Add User'}
            className='rollingcommission-model relative top-1 lg:top-7 lg:!w-[34vw]'
            onCancel={() => {
                setOpenAddUser(false);
                form.resetFields();
            }}
            footer={null}
            open={openAddUser}
        >
            <div className='grid grid-cols-12'>
                <div className='col-span-12  p-[20px]'>
                    <Form
                        form={form}
                        className='add-user-form'
                        name="basic"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 12,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Username"
                            name="user_name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Username is required.',
                                },
                            ]}
                        >
                            <Input className='lg:ml-[10px]' placeholder='Username...' />
                        </Form.Item>

                        <Form.Item
                            label="Name"
                            name="name"

                            rules={[
                                {
                                    message: 'Please input your name!',
                                },
                            ]}
                        >
                            <Input className='lg:ml-[10px]' placeholder='Name...' />
                        </Form.Item>

                        {!isCommission &&

                            <Form.Item
                                label="Commission(%) "
                                name="commission"

                                rules={[
                                    {
                                        required: true,
                                        message: 'Commission is required.',
                                    },
                                ]}
                            >

                                <Input type='number'
                                    max={uplineUserData?.commission ? uplineUserData?.commission : userdata?.master_commision}
                                    min={0} className='lg:ml-[10px]' placeholder='Commission...' />
                            </Form.Item>
                        }
                        <Form.Item
                            label="Opening Balance  "
                            name="opening_balance"

                            rules={[
                                {
                                    required: true,
                                    message: 'Opening Balance is required.',
                                },
                            ]}
                        >
                            <Input className='lg:ml-[10px]' placeholder='Opening Balance...' />
                        </Form.Item>
                        <Form.Item
                            label="Exposure Limit "
                            name="exposer_limit"

                            rules={[
                                {
                                    required: true,
                                    message: 'Exposure Limit is required.',
                                },
                            ]}
                        >
                            <Input type='number' className='lg:ml-[10px]' placeholder='Exposure Limit' />
                        </Form.Item>
                        <Form.Item
                            label="Credit Reference  "
                            name="credit_limit"
                            rules={[
                                {
                                    required: true,
                                    message: 'Credit Reference.. is required.',
                                },
                            ]}
                        >
                            <Input className='lg:ml-[10px]' placeholder='Credit Reference..' />
                        </Form.Item>
                        <Form.Item
                            label="Mobile Number"
                            name="phone"
                            rules={[
                                {
                                    required: true,
                                    message: 'Mobile Number is required.',
                                },
                            ]}

                        >
                            <Input className='lg:ml-[10px]' type='text' placeholder='Mobile Number ..' max={10} />
                        </Form.Item>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'User Password is required.',
                                },
                                {
                                    validator: (_, value) => {
                                        if (value.length < 8) {
                                            return Promise.reject(new Error('Password should be min 8 characters.'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input.Password className="lg:ml-[10px]" placeholder="Password..." />
                        </Form.Item>
                        <Form.Item
                            name="confirm_password"
                            label="Confirm Password"
                            dependencies={['password']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Passwords is not matched.'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password className='lg:ml-[10px]' placeholder='Confirm Password...' />
                        </Form.Item>
                        <Form.Item
                            label="Rolling Commission "
                            name="rolling_commission"
                            rules={[
                                {
                                    message: 'User Password is required.',
                                },
                            ]}
                        >
                            <div className="form-check form-check-inline float-left inline-flex items-center pl-[2px] mr-[.75rem] relative !ml-[.5rem] min-h-[1.5rem] mb-[.125rem]" >
                                <label htmlFor="chipSummaryOnOFF" className="switch switch-label switch-primary switch-lg w-[56px] h-[30px] inline-block mb-0 text-[0.938rem] leading-[28px]">
                                    <input id='chipSummaryOnOFF' name="chipSummaryOnOFF" type="checkbox" className="switch-input hidden" checked={isCommission} onChange={() => setIsCommission(!isCommission)} />
                                    <span data-checked="✓" data-unchecked="✕" className="switch-slider ">
                                    </span>
                                </label>
                            </div>
                        </Form.Item>
                        {isCommission && (
                            <>
                                <Form.Item
                                    label="Fancy"
                                    name="rolling_commission_fancy"
                                    initialValue={0}
                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Matka"
                                    name="rolling_commission_matka"
                                    initialValue={0}
                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Casino"
                                    name="rolling_commission_casino"
                                    initialValue={0}
                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Binary"
                                    name="rolling_commission_binary"
                                    initialValue={0}

                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Sportbook"
                                    name="rolling_commission_sportbook"
                                    initialValue={0}

                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Bookmaker"
                                    name="rolling_commission_bookmaker"
                                    initialValue={0}

                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                                <Form.Item
                                    label="Virtual Sports"
                                    name="rolling_commission_virtualsport"
                                    initialValue={0}

                                    rules={[
                                        {
                                            required: false,
                                        },
                                    ]}
                                >
                                    <Input type='number' className='lg:ml-[10px]' placeholder='0' />
                                </Form.Item>
                            </>
                        )}
                        {/* <Form.Item
                            label="Master Password  "
                            name="master_password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Master Password is required.',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        return new Promise((resolve, reject) => {
                                            if (value === userdata.password) {
                                                setIsDisabled(false);
                                                resolve();
                                            } else {
                                                setIsDisabled(true);
                                                reject('Incorrect Master Password.');
                                            }
                                        });
                                    },
                                }),
                            ]}
                        >
                            <Input.Password className='lg:ml-[10px]' placeholder='Master Password...' />
                        </Form.Item> */}
                        <Form.Item
                            label="Master Password"
                            name="master_password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Master Password is required.',
                                },
                                {
                                    validator: (_, value) => {
                                        if (value.length < 8) {
                                            return Promise.reject(new Error('Password should be min 8 characters.'));
                                        }

                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input.Password className="lg:ml-[10px]" placeholder="Master Password..." />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 16,
                            }}
                            className='flex items-center justify-center'
                        >
                            <Button type="primary"
                                htmlType="submit"
                                disabled={loading}
                                className='mt-[1rem] lg:ml-[10px] !text-[#fff] !bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] ' style={{ width: '140px' }}>
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </Modal>
    );
};

export default AddUserForm;